// src/components/AnimatedBG/index.js
import AnimatedBG from './AnimatedBG';

export default AnimatedBG;